import { FusaReply } from "@/types/replyTypes";
import { GetAllProductPageSectionsResponse, CreateProductPageSectionRequest, DuplicateProductPageSectionResponse } from "@/types/productPageSectionTypes";
import { Client } from "./client";
import { ProductPageSectionParams, ProductPageSectionType } from "@/backend/access/productPageSection/types";

export class ProductPageSectionController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  getAllByProcedureInstance(procedureInstanceId: string, type: ProductPageSectionType): Promise<GetAllProductPageSectionsResponse> {
    return this.client.read(`/api/product-page-sections/byProcedureInstanceAndType/${procedureInstanceId}/${type}`);
  }

  createProductPageSection(data: CreateProductPageSectionRequest): Promise<FusaReply & { productPageSection: ProductPageSectionParams }> {
    return this.client.create('/api/product-page-sections', data);
  }

  updateProductPageSection(section: ProductPageSectionParams): Promise<FusaReply & { productPageSection: ProductPageSectionParams }> {
    return this.client.update(`/api/product-page-sections/${section.id}`, section);
  }

  duplicateProductPageSection(id: string): Promise<DuplicateProductPageSectionResponse> {
    return this.client.create(`/api/product-page-sections/duplicate/${id}`, {});
  }

  orderProductPageSections(productPageSections: ProductPageSectionParams[]): Promise<GetAllProductPageSectionsResponse> {
    return this.client.update('/api/product-page-sections/order', { productPageSections });
  }

  deleteProductPageSection(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/product-page-sections/${id}`);
  }
}
